import { defineStore } from 'pinia'
import AvatarGif from '@/assets/image/touxiang.png'

export const useSystemStore = defineStore({
    id: 'app_system_store',
    state: () => ({
        permissionList: [],
        // 是不是第一次登录进入页面,是的话需要加载菜单接口数据,是否已动态添加了路由
        isFistLoginEntry: false,
        // 用户信息
        userInfo: {},
        //默认头像
        avatar: AvatarGif,
        // 信息总数
        total: 0,
        // 是否为润工作传入的链接
        isRunWorkLink: false,
    }),
    getters: {
        getUserInfoMation(){
            // console.log("进入了getUserInfo", this.userInfo); //刷新完成或首次进入时为默认值
            return this.userInfo
        },
        getUserAvatar(){
            // console.log("进入了getUserAvatar", this.avatar); //刷新完成或首次进入时为默认值
            return this.avatar || AvatarGif
        },
        getInfoAccount(){
            // console.log("计算了getInfoAccount", this.total); //刷新完成或首次进入时为默认值
            return this.total || 0
        },
        getIsRunWorkLink(){
            // console.log("QWQ QWQ QWQ QWQ QWQ", this.isRunWorkLink) // 刷新后，会变成false
            return this.isRunWorkLink || false
        },

    },
    actions: {
        /**
         * @description: 菜单权限
         * @param {*} val
         * @return {*}
         */
        setPermission(val){
            this.permissionList = val || []
        },
        /**
         * @description: 设置是否需要加载获取登录信息（菜单、用户信息等）接口
         * @param {*} val
         * @return {*}
         */
        setIsFistLoginEntry(val){
            this.isFistLoginEntry = val
        },
        /**
         * @description: 保存用户信息
         * @param {*} val
         * @return {*}
         */
        setUserInfo(val){
            // console.log("进入了setUserInfo", val);
            this.userInfo = val
        },
        setUserAvatar(val){
            // console.log("进入了setUserInfo", val);
            // this.avatar = val ? val.avatar : AvatarGif
            this.avatar = val ? val : AvatarGif
        },
        setInfoAccount(val){
            this.total = val || 0
        },
        setIsRunWorkLink(val){
            this.isRunWorkLink = val || false
        },
    },
})
